module.exports = __webpack_public_path__ + "static/media/disc.2a5e9e65.png";